export const environment = {
    production: true,
    apiUrl: 'https://be-dev.audacity.lcgtech.pt/',
    apiBackOfficeUrl: 'https://be-bo-dev.audacity.lcgtech.pt/',
};